module.exports = __webpack_public_path__ + "img/block-375.89b9c62a.jpg";